import { designLayoutSize } from '@/utils/export-pptx/constants'

/**
 * figma 設計稿的長寬是 1440 * 810 單位是 pixel
 * powerpoint 的長寬是 10 * 5.625 單位是 inch（https://gitbrent.github.io/PptxGenJS/docs/usage-pres-options/#standard-slide-layouts）
 *
 * 長寬及單位皆不一致，於是在這邊實作了單位轉換器，讓 export-pptx 能夠不理會單位的問題，直接照著設計稿的數字切版
 */
const pixelToInch = (px: number): number => px / 96
const inchToPixel = (inch: number): number => inch * 96
const pixelToPoint = (px: number): number => px * 0.75
const pointToPixel = (inch: number): number => inch / 0.75
const powerpointDefaultLayout = {
  h: inchToPixel(5.625),
  w: inchToPixel(10),
}
const magnification = {
  h: powerpointDefaultLayout.h / designLayoutSize.h,
  w: powerpointDefaultLayout.w / designLayoutSize.w,
}
const defaultToDesignWidth = (w: number): number =>
  inchToPixel(w / magnification.w)
const defaultToDesignHeight = (h: number): number =>
  inchToPixel(h / magnification.h)
const defaultToDesignFontSize = (fontSize: number): number =>
  pointToPixel(fontSize / magnification.h)
const designToDefaultWidth = (w: number): number =>
  pixelToInch(w * magnification.w)
const designToDefaultHeight = (h: number): number =>
  pixelToInch(h * magnification.h)
const designToDefaultFontSize = (fontSize: number): number =>
  pixelToPoint(fontSize * magnification.h)

const unitConverter = {
  pixelToInch,
  inchToPixel,
  pixelToPoint,
  pointToPixel,
  defaultToDesignWidth,
  defaultToDesignHeight,
  defaultToDesignFontSize,
  designToDefaultWidth,
  designToDefaultHeight,
  designToDefaultFontSize,
}

export default unitConverter
